// @flow
import * as React from 'react';
import Logging from '@ta/common.logging';
import { MentionsTrackingContext, aggregateTrackingStack } from './MentionsTrackingContext';
import MentionsImpressionContext from './MentionsImpressionContext';

type TrackImpressionWithContextInfo = (() => mixed) | null;

// A wrapper around a consumer. Used so the provided mutation can dynamically look at the nearest Provider when it is consumed, as opposed to when it was provided
const useMentionsImpressionContext = (): TrackImpressionWithContextInfo => {
  const trackingStack = React.useContext(MentionsTrackingContext);
  const trackImpression = React.useContext(MentionsImpressionContext);

  const memoizedTrackImpressions = React.useCallback(() => {
    const {
      locationId,
      sectionId,
      placement,
      objectTypes,
      sessionType,
      owner,
      puid,
    } = aggregateTrackingStack(trackingStack);
    if (!locationId) {
      Logging.error('No location id was provided. This is a no-op!');
      return;
    }
    if (!sectionId) {
      Logging.error('No section id was provided. This is a no-op!');
      return;
    }
    if (!placement) {
      Logging.error('No placement was provided. This is a no-op!');
      return;
    }
    if (!objectTypes) {
      Logging.error('No objects types were provided. This is a no-op!');
      return;
    }
    if (!sessionType) {
      Logging.error('No session type was provided. This is a no-op!');
      return;
    }
    if (!puid) {
      Logging.error('No page uid was provided. This is a no-op!');
      return;
    }
    if (trackImpression) {
      trackImpression(
        ({
          allowedTypes: objectTypes,
          locationId,
          owner,
          placement,
          puid,
          sectionId,
        }: any),
      );
    }
  }, [trackImpression, trackingStack]);
  return trackImpression && memoizedTrackImpressions;
};

export default useMentionsImpressionContext;
